// UserSearchInput.jsx
import React, { useCallback } from 'react';
import './UserSearchInput.css';
import { TbSearch, TbX } from "react-icons/tb";

const UserSearchInput = ({ placeholder, onSearch, value = "", style }) => {
  const handleChange = (e) => {
    onSearch && onSearch(e.target.value);
  };

  const handleClear = useCallback(() => {
    onSearch && onSearch("");
  }, [onSearch]);

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      handleClear();
      e.currentTarget.blur();
    }
  };

  const hasValue = Boolean(value && String(value).trim().length);

  return (
    <div className="search-container" style={style}>
      <input
        type="text"
        value={value}
        className="search-input"
        placeholder={placeholder || 'Search'}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        aria-label={placeholder || 'Search'}
      />
      {hasValue ? (
        <span
        style={{cursor:"var(--pointer)"}}
          className="search-icon"
          onClick={handleClear}
        >
          <TbX size={18} />
        </span>
      ) : (
        <span className="search-icon" aria-hidden="true">
          <TbSearch size={18} />
        </span>
      )}
    </div>
  );
};

export default UserSearchInput;